import React, { useState, useEffect } from "react";
import "./hero-section.styles.css";

const HeroSection = () => {
  const [dateStr, setDateStr] = useState("");
  const [timeStr, setTimeStr] = useState("");

  useEffect(() => {
    const update = () => {
      const now = new Date();
      setDateStr(
        now.toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
          timeZone: "Asia/Kolkata",
        })
      );
      setTimeStr(
        now.toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "2-digit",
          timeZone: "Asia/Kolkata",
        })
      );
    };
    update();
    const id = setInterval(update, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <section className="me-top">
      <div className="me-top-left">
        <div className="name-wrapper">
          <div className="name-first">
            <h2 className="h2">PANKAJ VYAS</h2>
            <div className="tagline-wrapper">
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
